var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import id from "@irati/utils/id";
import userBackgroundColor from "@irati/utils/userBackgroundColor";
import { Avatar } from "@irati/ui/src/Typography";
import { Pic } from "./styled";
var DefaultProfilePicture = function (_a) {
    var _b = _a.firstname, firstname = _b === void 0 ? "" : _b, _c = _a.lastname, lastname = _c === void 0 ? "" : _c, size = _a.size, props = __rest(_a, ["firstname", "lastname", "size"]);
    var deactivated = props.deactivated, border = props.border, marginRight = props.marginRight;
    var idNamespace = id("default-profile-picture", props);
    var firstNameInitial = firstname ? firstname.charAt(0).toUpperCase() : "";
    var lastNameInitial = lastname ? lastname.charAt(0).toUpperCase() : "";
    var initials = "" + firstNameInitial + lastNameInitial;
    var getTypographySize = function () {
        if (size) {
            if (size <= 30)
                return { small: true };
            else if (size <= 50)
                return { regular: true };
            else if (size >= 100)
                return { large: true };
        }
        return undefined;
    };
    return (React.createElement(Pic, { id: idNamespace, size: size, border: border, color: userBackgroundColor(firstname, deactivated), marginRight: marginRight },
        React.createElement(Avatar, __assign({ id: id("title", idNamespace) }, getTypographySize()), initials)));
};
export default DefaultProfilePicture;
